module.exports = __webpack_public_path__ + "img/ecf1ab75830ecb36b19d363e0590408a.png";